import React from "react";
import { Col, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../Calculators/RangeSplitter";

export default function TestScaleDesign_1({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scales);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  // Default colors matching Summary_L_Bar
  const progressColor = "#4a90e2";
  const backgroundColor = "#e0e0e0";

  return (
    <Row
      className="mb-3 mt-3 justify-content-center mx-0"
      style={{
        borderRadius: "20px",
      }}
    >
      <Col>
        <Row className="mb-3">
          <Col className={"align-content-center"}>
            <Row>
              {splitRanges.beforeHitRangeList.map((range, i) => {
                return (
                  <Col key={i + "-" + range.id + "scopeScale"} className={"hit-scale-style-test-wrap-up p-0"}>
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: backgroundColor,
                        borderRadius: "18px",
                        overflow: "hidden",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: "800",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          backgroundColor: progressColor,
                          borderRadius: "18px",
                        }}
                      />
                      <span style={{ position: "relative", zIndex: 1, color: "#fff" }}>{range.text}</span>
                    </div>
                  </Col>
                );
              })}
              <Col key={"hitScopeScale"} className={"hit-scale-style-test-wrap-up p-0"}>
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: backgroundColor,
                    borderRadius: "18px",
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "800",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      backgroundColor: progressColor,
                      borderRadius: "18px",
                    }}
                  />
                  <span style={{ position: "relative", zIndex: 1, color: "#fff" }}>{splitRanges.hitRange.text}</span>
                </div>
              </Col>

              {splitRanges.afterHitRangeList.map((range, i) => {
                return (
                  <Col key={i + "-" + range.id + "scopeScale"} className={"hit-scale-style-test-wrap-up p-0"}>
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: backgroundColor,
                        borderRadius: "18px",
                        overflow: "hidden",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: "800",
                      }}
                    >
                      <span style={{ position: "relative", zIndex: 1, color: "#333" }}>{range.text}</span>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
